import { combineReducers } from 'redux';
import { Api } from '../../../core/api';

const apiFetchArticleInfo = new Api({
  initialData: {
    slug: '',
    title: '',
  },
  namespace: 'ARTICLE_INFO',
  useEagleApi: true,
});

export const fetchArticle = (id: string) =>
  apiFetchArticleInfo.fetch({
    url: `/internal-intranet/articles/${id}`,
  });

const createArticleApi = new Api({
  namespace: 'CREATE_ARTICLE',
  useEagleApi: true,
  options: {
    method: 'POST',
  },
  url: `/internal-intranet/articles`,
});

const editArticleApi = new Api({
  namespace: 'EDIT_ARTICLE',
  useEagleApi: true,
  options: {
    method: 'PUT',
  },
});

export const createArticle = (data: any) =>
  createArticleApi.fetch({ options: { body: JSON.stringify(data) } });

export const editArticle = (id: string, data: any) =>
  editArticleApi.fetch({
    options: { body: JSON.stringify(data) },
    url: `/internal-intranet/articles/${id}`,
  });

export const resetArticleForm = apiFetchArticleInfo.reset;

const apiFetchCategories = new Api({
  namespace: 'CATEGORIES_LIST',
  url: '/categories',
});

export const fetchCategories = apiFetchCategories.fetch;

const checkSlugsApi = new Api({
  useEagleApi: true,
  options: {
    method: 'GET',
  },
});

export const checkSlugs = (slug: string) => {
  if (slug) {
    return checkSlugsApi.simpleFetch({
      url: `/internal-intranet/articles/has-slug/${slug}`,
    });
  }
  return false;
};

export const reducer = combineReducers({
  article: apiFetchArticleInfo.reducer,
  categories: apiFetchCategories.reducer,
});
